import React from "react"
import {theme} from "@indebted/theme"
import {Layout} from "@indebted/components/Layout"
import {NotificationProvider} from "@indebted/components/Notification"
import {CssBaseline, MuiThemeProvider} from "@material-ui/core"
import {Security} from "@okta/okta-react"
import {navigate} from "@reach/router"
import {toRelativeUrl} from "@okta/okta-auth-js"

import {Routes} from "./routes"
import {oktaAuth} from "./config/okta"

export const App = () => {
	const restoreOriginalUri = (_oktaAuth, originalUri) => {
		navigate(toRelativeUrl(originalUri || "/", window.location.origin), {replace: true})
	}

	return (
		<MuiThemeProvider theme={theme}>
			<CssBaseline />
			<NotificationProvider>
				<Layout>
					<Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
						<Routes />
					</Security>
				</Layout>
			</NotificationProvider>
		</MuiThemeProvider>
	)
}
